import { defineComponent as _defineComponent } from 'vue'
import { computed, Ref, ref } from "vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import {
    BorrowCalculatorInterface,
    BorrowCalculatorFields,
    CalculatorOptions,
    CalculatorOptionsFields,
    Periodicity,
    getPeriodicityKey,
  } from "@/types/BorrowCalculator";
  import { formatPriceTrim } from "@/helpers/transformation/price";

  type propsType = {
    form: BorrowCalculatorInterface;
    formCalculatorOptions: CalculatorOptions;
  };
  
export default /*@__PURE__*/_defineComponent({
  __name: 'CalculatorExpensesSection',
  props: {
    form: {},
    formCalculatorOptions: {}
  },
  emits: ["updateForm", "updateFormCalculatorOptions"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;

  const props = __props;

  const updateForm = (field: BorrowCalculatorFields, value: string) => {
    emits("updateForm", field.toString(), value);
  };

  const updateFormInput = (e: Event, field: BorrowCalculatorFields) => {
    e.preventDefault();
    const target = e.target as HTMLInputElement;
    const income = formatPriceTrim(target.value);

    emits("updateForm", field, income);
  };

const __returned__ = { emits, props, updateForm, updateFormInput, computed, Ref, ref, DropDown, get BorrowCalculatorInterface() { return BorrowCalculatorInterface }, get BorrowCalculatorFields() { return BorrowCalculatorFields }, get CalculatorOptions() { return CalculatorOptions }, get CalculatorOptionsFields() { return CalculatorOptionsFields }, get Periodicity() { return Periodicity }, get getPeriodicityKey() { return getPeriodicityKey }, get formatPriceTrim() { return formatPriceTrim } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})